"use strict";
import { RouterPreference } from "state/routing/types";
import { UniverseChainId } from "uniswap/src/features/chains/types";
export const FORCE_CLASSIC_ROUTING = true;
export const DEFAULT_ROUTER_PREFERENCE = RouterPreference.API;
export const SUPPORTED_ROUTING_METHODS = [RouterPreference.API];
export function isSupportedRouterPreference(preference) {
  return preference === RouterPreference.API;
}
export function getEnforcedRouterPreference() {
  return RouterPreference.API;
}
export const ROUTING_CONFIG_MESSAGE = "This application uses Universal Router with Permit2 for optimal gas efficiency and security.";
export const BASES_TO_TRACK_LIQUIDITY_FOR = {
  [UniverseChainId.H2]: []
  // 代币从接口动态获取
};
export const PINNED_PAIRS = {
  [UniverseChainId.H2]: []
  // 交易对从接口动态获取
};
